export default {
	EmailReceiveAlerts: [],
	Total: 0,
	EmailReceiveAlert: {}
};
